<div class="hmhs-dynamic-form mat-typography mat-body mat-app-background" #individualPlanReview>

  @if (!formConfig.form.customConfigs?.reviewOnly) {
    <!-- Form Page Heading -->
    @if (formConfig.pages[currentPage]?.showPageHeader) {
      <h1 class="form-heading">
      Review and Submit your Application</h1>
    }
    <!-- <h4><a href="#"> Click here to view your Summary of Benefits and Coverage</a></h4> -->
    <span>Please review your application responses to verify your information.</span>
    <!-- Form Entries Loop  *ngIf="reviewConfigReady -->
    @for (entry of formConfig.pages[currentPage]?.custom?.entriesDefaultBehavior; track entry; let i = $index) {
<div
      class="form-row" [ngClass]="{ 'hide-entry': entry.base?.foreverHidden }">
        <ptl-entry-as-json [entryConfig]="entry" [form]="pageFormGroups" [formConfig]="formConfig">
        </ptl-entry-as-json>
      </div>
    }
  }

  @if (reviewConfigReady) {
    @for (entry of formConfig.pages[currentPage]?.entries; track entry; let i = $index) {
      <div class="form-row"
        [ngClass]="{ 'hide-entry': entry.base?.foreverHidden }">
        @if (entry.pageNumber <= currentPage) {
          <!-- CONTROL VALUE + EDIT -->
          @if ((
            entry.formControlAttributes?.formControlName &&
            retrieveEntry(entry, true) !== null &&
            retrieveEntry(entry, true) !== undefined &&
            !entry.custom?.doNotDisplayOnReviewPage
            )) {
            <div>
              <div class="reviewData">
                <div class="marginBottom">
                  <b [innerHTML]="entry?.formControlAttributes?.label"></b>
                </div>
                {{ retrieveEntry(entry) || "Review" }}
              </div>
              @if (!formConfig.form.customConfigs?.reviewOnly && entry.formControlAttributes?.formControlName) {
                <button mat-raised-button
                  class="edit-button" color="secondary" (click)="editQuestion(entry)">
                  Edit
                </button>
              }
            </div>
          } @else {
            @if (entry.custom?.displayOnPrintReview) {
              @if (entry?.base?.display) {
                <div [innerHTML]="retrieveSafeHTML(entry)"></div>
              }
            }
          }
          <!-- CONTENT VALUE-->
        }
      </div>
    }
  }

  <!-- Form Page Nav BUTTONS -->
  @if (!formConfig.form.customConfigs?.reviewOnly) {
    <div class="form-buttons">
      @if (formConfig.form.formNavigation.saveButton.display) {
        <div class="save-later">
          <a href="javascript:void(0)" (click)="saveForLaterButton()">
            <span class="text">SAVE FOR LATER</span>
            <span class="material-symbols-outlined save-icon">save</span>
          </a>
        </div>
      }
      <div class="navigational-controls">
        @if (formConfig.form.formNavigation.backButton.display && currentPage !== 0) {
          <div class="nav-link">
            <a href="javascript:void(0)" (click)="backButton()">
              <span class="material-symbols-outlined">arrow_back</span>
              <span class="text left-text">BACK</span>
            </a>
          </div>
        }
        @if (formConfig.form.formNavigation.nextButton.display && currentPage !== formConfig.pages.length - 1) {
          <div class="nav-link spacer" [ngClass]="{'disable-link' : false }"
            >
            <a href="javascript:void(0)" (click)="nextButton()">
              <span class="text">NEXT</span>
              <span class="material-symbols-outlined">arrow_forward</span>
            </a>
          </div>
        }
      </div>
      @if (currentPage === formConfig.pages.length - 1) {
        <button mat-raised-button color="primary" class="submit-button"
          [disabled]="isSubmitting" (click)="submitButton()">
          SUBMIT
        </button>
      }
    </div>
  }
</div>